var _rect, _g, _g2, _path, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoInApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1019,
    height: 345,
    viewBox: "0 0 1019 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_495_2362",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 320,
    height: 320
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 319.876,
    height: 320,
    rx: 159.938,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_495_2362)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319.876,
    height: 320,
    rx: 159.938,
    fill: "#98D6B1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_495_2362)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.141 312.599C531.954 177.431 514.685 -24.4444 379.569 -138.302C244.454 -252.159 42.6571 -234.883 -71.1558 -99.7146C-131.756 -27.7437 -155.193 63.1393 -143.466 149.578C-136.058 204.176 -50.3286 182.353 -14.8465 140.213C61.7186 49.2817 197.473 37.6597 288.369 114.255C339.246 157.127 365.285 218.551 364.925 280.272C364.757 309.175 399.528 334.704 418.141 312.599Z",
    fill: "#76A3E7"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76,
    filter: "url(#filter1_f_495_2362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.665,
    cy: 356.359,
    rx: 94.5087,
    ry: 94.5454,
    fill: "#FFA553"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter2_f_495_2362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.338,
    cy: 317.098,
    rx: 121.359,
    ry: 105.699,
    fill: "#FFA553"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_495_2362)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.802,
    cy: 82.2107,
    r: 43.0627,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter4_f_495_2362)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.8704,
    cy: 246.632,
    r: 43.0627,
    fill: "#222222",
    fillOpacity: 0.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_2362)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_495_2362)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8597 -66.3925H-66.3862V48.8534V279.345V394.591H48.8597H279.352H394.597V279.345V48.8534V-66.3925H279.352H48.8597ZM164.106 48.8534C164.106 -14.7952 112.508 -66.3925 48.8597 -66.3925C-14.7889 -66.3925 -66.3862 -14.7952 -66.3862 48.8534C-66.3862 112.502 -14.7889 164.099 48.8597 164.099C-14.7889 164.099 -66.3862 215.697 -66.3862 279.345C-66.3862 342.994 -14.7889 394.591 48.8597 394.591C112.508 394.591 164.106 342.994 164.106 279.345C164.106 342.994 215.703 394.591 279.352 394.591C343 394.591 394.597 342.994 394.597 279.345C394.597 215.697 343 164.099 279.352 164.099C343 164.099 394.597 112.502 394.597 48.8534C394.597 -14.7952 343 -66.3925 279.352 -66.3925C215.703 -66.3925 164.106 -14.7952 164.106 48.8534ZM164.106 48.8534C164.106 112.502 215.703 164.099 279.352 164.099C215.703 164.099 164.106 215.697 164.106 279.345C164.106 215.697 112.508 164.099 48.8597 164.099C112.508 164.099 164.106 112.502 164.106 48.8534Z",
    fill: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M164.421 7.82906C214.335 4.53802 303.2 53.3273 313.183 148.761C256.614 148.761 187.714 93.3906 164.421 7.82906Z",
    fill: "url(#paint0_radial_495_2362)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65,
    filter: "url(#filter6_f_495_2362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.854 70.4586C280.241 72.7244 269.285 59.4956 251.472 46.8157C233.659 34.1359 217.613 21.8391 219.226 19.5732C220.839 17.3074 240.564 26.467 258.377 39.1469C276.19 51.8267 283.467 68.1928 281.854 70.4586Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter7_f_495_2362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.419,
    cy: 289.695,
    rx: 62.6367,
    ry: 23.4888,
    fill: "#EDD06A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.5 163.428C1013.08 160.382 1007.41 158.858 1001.49 158.858C994.044 158.858 987.867 161.312 982.959 166.22C978.051 170.959 973.736 176.883 970.012 183.991V255.579H937.772V127.38H970.012V151.496C974.413 143.881 979.574 137.534 985.498 132.457C991.59 127.38 998.445 124.841 1006.06 124.841C1010.63 124.841 1014.78 125.603 1018.5 127.126V163.428Z",
    fill: "#51769A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M891.364 60.6138C897.456 60.6138 902.703 62.8139 907.103 67.2141C911.503 71.4452 913.703 76.5224 913.703 82.4458C913.703 88.2 911.503 93.2772 907.103 97.6774C902.703 102.078 897.456 104.278 891.364 104.278C885.271 104.278 880.024 102.078 875.624 97.6774C871.393 93.2772 869.278 88.2 869.278 82.4458C869.278 76.5224 871.393 71.4452 875.624 67.2141C880.024 62.8139 885.271 60.6138 891.364 60.6138ZM910.149 127.379V255.579H877.909V154.796H857.346V127.379H910.149Z",
    fill: "#51769A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M766.785 124.078C773.724 124.078 780.748 125.686 787.856 128.902C794.964 132.117 800.887 136.433 805.626 141.849V127.379H837.866V255.578H805.626V234C801.903 240.939 796.487 246.947 789.379 252.024C782.271 256.932 773.978 259.386 764.5 259.386C754.177 259.386 744.615 256.763 735.814 251.517C727.183 246.27 720.244 238.654 714.998 228.669C709.751 218.684 707.128 206.583 707.128 192.367C707.128 178.151 709.751 165.965 714.998 155.811C720.413 145.657 727.606 137.872 736.576 132.456C745.715 126.871 755.785 124.078 766.785 124.078ZM773.386 155.557C766.616 155.557 760.777 157.334 755.869 160.888C751.13 164.273 747.407 168.758 744.699 174.343C741.991 179.928 740.638 185.936 740.638 192.367C740.638 202.014 743.515 210.222 749.269 216.991C755.192 223.761 762.977 227.146 772.624 227.146C778.378 227.146 783.709 225.623 788.617 222.576C793.694 219.53 797.756 215.299 800.803 209.883C804.018 204.298 805.626 197.613 805.626 189.828V171.55C801.056 166.642 796.064 162.75 790.648 159.873C785.402 156.996 779.647 155.557 773.386 155.557Z",
    fill: "#51769A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M645.993 124.08C659.024 124.08 669.94 128.481 678.741 137.281C687.541 146.082 691.941 159.282 691.941 176.883V255.58H659.701L659.447 181.199C659.447 172.568 657.332 166.137 653.101 161.906C649.039 157.675 643.369 155.559 636.092 155.559C630.338 155.559 624.922 157.421 619.845 161.144C614.937 164.867 610.706 169.268 607.152 174.345V255.58H574.912V72.8005H607.152V145.659C611.044 140.412 616.291 135.504 622.891 130.935C629.661 126.365 637.361 124.08 645.993 124.08Z",
    fill: "#51769A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M471.38 72.8005V184.499L523.675 127.381H564.039L508.697 182.976L566.832 255.58H526.214L487.373 204.554L471.38 220.547V255.58H439.14V72.8005H471.38Z",
    fill: "#51769A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_495_2362",
    x: -295.832,
    y: -363.007,
    width: 938.649,
    height: 833.409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 74.7208,
    result: "effect1_foregroundBlur_495_2362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_495_2362",
    x: -91.2849,
    y: 112.372,
    width: 487.901,
    height: 487.974,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 74.7208,
    result: "effect1_foregroundBlur_495_2362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_495_2362",
    x: -102.463,
    y: 61.9569,
    width: 541.601,
    height: 510.282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 74.7208,
    result: "effect1_foregroundBlur_495_2362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_495_2362",
    x: 133.103,
    y: -23.4888,
    width: 211.399,
    height: 211.399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.3183,
    result: "effect1_foregroundBlur_495_2362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_495_2362",
    x: -7.82908,
    y: 140.933,
    width: 211.399,
    height: 211.399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.3183,
    result: "effect1_foregroundBlur_495_2362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_495_2362",
    x: -97.7046,
    y: -113.37,
    width: 523.621,
    height: 523.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -15.6592
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.6592
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995718 0 0 0 0 0.989423 0 0 0 0 0.838332 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_495_2362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_495_2362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_495_2362",
    x: 211.284,
    y: 11.3985,
    width: 78.6177,
    height: 67.1448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.91479,
    result: "effect1_foregroundBlur_495_2362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_495_2362",
    x: 70.4644,
    y: 234.888,
    width: 187.91,
    height: 109.614,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.6592,
    result: "effect1_foregroundBlur_495_2362"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_495_2362",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254.461 50.8915) rotate(121.329) scale(105.409 111.986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_2362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215.46,
    height: 215.46,
    fill: "white",
    transform: "translate(53.8682 53.8651)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInApp);
export default __webpack_public_path__ + "static/media/logo-in-app.a2f809885ff8f4b8a6e8de57fc067007.svg";
export { ForwardRef as ReactComponent };